import { IconX } from '@tabler/icons-react'
import { ProfTag } from '@/models/profTag.ts'

const DEFAULT_TAG_COLOR = '#7EB6E6'

interface TagBadgeProps {
  tag: ProfTag
  onRemove?: () => void
  onClick?: () => void
  onColorClick?: () => void
  size?: 'sm' | 'md'
  active?: boolean
}

export default function TagBadge({ tag, onRemove, onClick, onColorClick, size = 'md', active = false }: TagBadgeProps) {
  const isSmall = size === 'sm'

  const bgColor = tag.color ? `#${tag.color}` : DEFAULT_TAG_COLOR

  return (
    <span
      className={`badge inline-flex items-center gap-1.5 border-0 ${isSmall ? 'badge-sm' : ''} ${active ? 'badge-primary' : ''} ${onClick ? 'cursor-pointer hover:opacity-80' : ''}`}
      style={!active ? { backgroundColor: `${bgColor}20`, color: bgColor } : undefined}
      onClick={onClick}
    >
      <span
        className={`${isSmall ? 'w-2 h-2' : 'w-2.5 h-2.5'} rounded-full shrink-0 ${onColorClick ? 'cursor-pointer hover:ring-2 hover:ring-primary' : ''}`}
        style={{ backgroundColor: bgColor }}
        onClick={onColorClick ? (e) => { e.stopPropagation(); onColorClick() } : undefined}
      />
      <span className="truncate max-w-[120px]">{tag.name}</span>
      {onRemove && (
        <button
          className="hover:text-error -mr-1"
          onClick={(e) => { e.stopPropagation(); onRemove() }}
        >
          <IconX size={isSmall ? 12 : 14} />
        </button>
      )}
    </span>
  )
}
